import { makeStyles, tokens } from '@fluentui/react-components';
import { useQuickLinksPanelStyles } from '@layouts/QuickLinks/QuickLinksPanel.styles';

/**
 * Spec 097-footer-help-revamp FR-008: the Contacts section MUST visually match
 * Quick Links. Re-export the same style hook so any future Quick Links style
 * change automatically propagates here.
 *
 * Spec 099-employee-module-fixes (US7 / FR-009, FR-010): the contact section
 * additionally renders each contact value as a Fluent UI `Link` with the
 * link/primary blue color token, visually differentiated from the descriptive
 * label which uses the standard foreground color. The extra styles below are
 * merged into the same hook via a wrapping function.
 */
const useContactReadabilityStyles = makeStyles({
  contactRow: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    columnGap: '0.25rem',
    rowGap: '0.125rem',
    width: '100%',
  },
  contactLabel: {
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
  contactValue: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightRegular,
  },
});

export const useContactsPanelStyles = () => {
  const base = useQuickLinksPanelStyles();
  const extras = useContactReadabilityStyles();
  return { ...base, ...extras } as typeof base & typeof extras;
};
